import { COLOR, Dart, DART_HITS, DART_NUMBER } from "./dart";
import { GAME_STATE } from "./game";

export enum ROUND_TYPE {
  ESTABLISH = "Establish score",
  DOUBLE = "Any double",
  TRIPLE = "Any triple",
  SEL_SCORE = "Selected score",
  SEL_NUMBER = "Selected number",
  SEL_COLOR = "Selected color",
  IN_BED = "3 in the bed",
  // SEQ_COLOR = "Color sequence",
  // SEQ_NUM = "Number sequence",
  COLOR_DIFF = "3 different colors",
  BULLS = "Bulls"
}

export interface Round {
  type: ROUND_TYPE;
  score?: number;
  number?: DART_NUMBER;
  multiplier?: DART_HITS;
  color?: COLOR;
  numbers?: DART_NUMBER[];
  colors?: COLOR[]
}

export interface HalvesPlayerRound {
  score: number,
  roundType: ROUND_TYPE,
  darts: Dart[],
  success: boolean;
  startingScore: number;
  endingScore: number;
}

export interface HalvesPlayerState {
  score: number;
  name: string;
  currentRound?: HalvesPlayerRound;
  pastRounds: HalvesPlayerRound[];
}

export interface HalvesGameState {
  rounds: Round[];
  currentRound: Round;
  gameState: GAME_STATE;
  throwNumber: number;
  currentPlayer: string;
  winner?: string;
  players: HalvesPlayerState[];
}